import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from 'bento-ordering/base/ui_components/CloseButton';

// TODO: refactor to reference this from themes instead
import { WHITE } from 'styles/theme/colors';

const ModalCloseButton = ({ handleClick, isWhite, autoFocus }) => (
  <CloseButton
    autoFocus={autoFocus}
    right={2}
    top={2}
    handleClick={handleClick}
    color={isWhite ? WHITE : null}
  />
);

ModalCloseButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isWhite: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export default ModalCloseButton;
